<template>
  <SeoPage page-key="ottimizzazioneSeoLocarno" />
</template>

<script setup>
import SeoPage from '../components/SeoPage.vue'

defineOptions({
  name: 'OttimizzazioneSeoLocarnoPage'
})
</script>

